import { generateLabelStatusCommand } from "./generateStatusCommand";

export default generateLabelStatusCommand;
